import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { cn } from "@volca/ui/lib/utils";
import { ChatTable } from "./chat-table";
import { CHAT_TYPESET_CLASS } from "./constants";
import { MathEquation } from "./math-equation";
import { remarkChatMath } from "./remark-chat-math";

const components: Components = {
  // Inline when it fits the reply; else a card that opens it whole, never a
  // table scrolling sideways inside the conversation (`ChatTable`).
  table: ({ node: _node, ...props }) => <ChatTable {...props} />,
  span: ({ node, ...props }) => {
    const source = node?.properties["data-chat-math"];
    return typeof source === "string" ? (
      <MathEquation
        source={source}
        complete={node?.properties["data-math-complete"] === true}
      />
    ) : (
      <span {...props} />
    );
  },
};

interface ChatMarkdownProps {
  children: string;
  streaming?: boolean;
  className?: string;
}

export const ChatMarkdown = ({
  children,
  streaming = false,
  className,
}: ChatMarkdownProps) => (
  // max-w-full keeps a shrink-to-fit parent (e.g. a flex column with
  // items-start) from sizing the reply to its widest table. Nothing in a
  // reply scrolls it sideways: words wrap, a wide table is a card
  // (`ChatTable`), and only a code block or an equation scrolls within itself.
  <div className={cn(CHAT_TYPESET_CLASS, "max-w-full", className)}>
    <ReactMarkdown
      remarkPlugins={[
        remarkGfm,
        [remarkChatMath, { allowIncomplete: streaming }],
      ]}
      components={components}
    >
      {children}
    </ReactMarkdown>
  </div>
);
